'use client';
import React, { useState } from 'react';
import { Search, Plus, Edit3, Check } from 'lucide-react';
export default function NewsItemsManagers() {
  const [searchTerm, setSearchTerm] = useState('');
  const [newsItems, setNewsItems] = useState([
    {
      title: 'New online store is open!',
      language: 'EN',
      comments: 1,
      startDate: '',
      endDate: '',
      published: true,
      createdOn: '02/11/2025 10:34:48 PM',
    },
    {
      title: 'routekart new release!',
      language: 'EN',
      comments: 1,
      startDate: '',
      endDate: '',
      published: true,
      createdOn: '02/11/2025 10:34:47 PM',
    },
    {
      title: 'About routekart',
      language: 'EN',
      comments: 1,
      startDate: '',
      endDate: '',
      published: true,
      createdOn: '02/11/2025 10:34:46 PM',
    },
  ]);
  const filteredItems = newsItems.filter((item) =>
    item.title.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <div className="p-4 sm:p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-semibold text-gray-800">News items</h1>
        <button className="flex items-center gap-1 bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-md text-sm">
          <Plus size={16} />
          Add new
        </button>
      </div>
      {/* Search Card */}
      <div className="bg-white rounded-md shadow-sm border border-gray-200 mb-6">
        <div className="flex items-center px-4 py-3 border-b">
          <Search className="text-gray-600 mr-2" />
          <span className="font-medium text-gray-800">Search</span>
        </div>
        <div className="p-4 flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex items-center gap-2 w-full sm:w-1/2">
            <label className="text-gray-700 font-medium text-sm whitespace-nowrap">
              Title
            </label>
            <input
              type="text"
              placeholder="Search by title"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-1.5 w-full focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>
          <button
            onClick={() => {}}
            className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-md"
          >
            <Search size={18} /> Search
          </button>
        </div>
      </div>
      {/* Table */}
      <div className="bg-white rounded-md shadow-sm border border-gray-200">
        <div className="px-4 py-2 border-b text-sm text-gray-600">
          Learn more about{' '}
          <span className="text-blue-600 font-medium cursor-pointer hover:underline">
            news
          </span>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-gray-700">
            <thead className="bg-gray-100 text-left">
              <tr>
                <th className="px-4 py-2 font-semibold border">Title</th>
                <th className="px-4 py-2 font-semibold border">Language</th>
                <th className="px-4 py-2 font-semibold border">View comments</th>
                <th className="px-4 py-2 font-semibold border">Start date</th>
                <th className="px-4 py-2 font-semibold border">End date</th>
                <th className="px-4 py-2 font-semibold border">Published</th>
                <th className="px-4 py-2 font-semibold border">Created on</th>
                <th className="px-4 py-2 font-semibold border">Edit</th>
              </tr>
            </thead>
            <tbody>
              {filteredItems.map((item, idx) => (
                <tr key={idx} className="odd:bg-white even:bg-gray-50">
                  <td className="px-4 py-2 border">{item.title}</td>
                  <td className="px-4 py-2 border">{item.language}</td>
                  <td className="px-4 py-2 border">
                    <button className="border border-gray-300 px-3 py-1 rounded hover:bg-gray-100">
                      View comments - {item.comments} (0)
                    </button>
                  </td>
                  <td className="px-4 py-2 border">{item.startDate}</td>
                  <td className="px-4 py-2 border">{item.endDate}</td>
                  <td className="px-4 py-2 border text-center">
                    {item.published && <Check className="text-blue-600 mx-auto" size={18} />}
                  </td>
                  <td className="px-4 py-2 border">{item.createdOn}</td>
                  <td className="px-4 py-2 border text-center">
                    <button className="flex items-center gap-1 text-gray-700 border border-gray-300 rounded px-3 py-1 hover:bg-gray-100 mx-auto">
                      <Edit3 size={16} /> Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="flex flex-col sm:flex-row justify-between items-center px-4 py-3 text-sm text-gray-600">
          <div className="flex gap-2 mb-2 sm:mb-0">
            <button className="px-3 py-1 border rounded hover:bg-gray-100">
              Previous
            </button>
            <button className="px-3 py-1 border rounded bg-blue-600 text-white">
              1
            </button>
            <button className="px-3 py-1 border rounded hover:bg-gray-100">
              Next
            </button>
          </div>
          <div className="flex items-center gap-2">
            <span>Show</span>
            <select className="border border-gray-300 rounded px-2 py-1 focus:ring-blue-500 focus:outline-none">
              <option>15</option>
              <option>30</option>
              <option>50</option>
            </select>
            <span>items</span>
          </div>
          <span className="mt-2 sm:mt-0">1–{filteredItems.length} of {newsItems.length} items</span>
        </div>
      </div>
    </div>
  );
}
